import IdConstants from '../data/idConstants';
import { accessRoles } from '../data/appConstants';

const getUserId = (userDetails) => {
  const storedItem = localStorage.getItem(
    IdConstants.selectedCompanyObject.selectedCompany
  );
  const isSalesRepApproved = userDetails?.roles?.includes(accessRoles.sales_rep);
  const parsedItem = storedItem ? JSON.parse(storedItem) : null;
  const selectedCompanyId = parsedItem ? parsedItem.id : null;
  const salesRepRole = userDetails?.roles[0] === accessRoles.sales_rep && userDetails?.roles[0];
  return `${salesRepRole === accessRoles.sales_rep && isSalesRepApproved ? selectedCompanyId : localStorage.getItem(IdConstants.userId)}`;
};

export default getUserId;
